<template>
  <div class="ceiba-join-club-popup">
    <!-- 黑色遮罩层 -->
    <div :class="getCss('mask-layer')" v-show="popupShow"></div>
    <!-- 浮层内容 -->
    <div :class="getCss('content')" ref="popupContent">
      <!-- 加入俱乐部-答题 -->
      <template v-if="isShowJoinQuestion">
        <img src="https://act.xinyue.qq.com/activity/tgclub/14011/78b238d4b75d6b44a07d219906de99b5.png"
             :class="getCss('content_close')" @click="close" />
        <div :class="getCss('content_answer-questions')">
          <div>
            <h1>填写俱乐部申请</h1>
            <div :class="getCss('number-of-clubs')">
              你当前还可以加入
              <span>{{ problemData.allowCount }}</span>
              个俱乐部
              <img @click="openTips"
                   src="https://act.xinyue.qq.com/activity/tgclub/14011/98d18239b3d2d35d3f78c324db59d5d0.png" alt="" />
            </div>
          </div>
          <div :class="getCss('questions')">
            请回答问题：{{ problemData.question }}
          </div>
          <textarea :class="getCss('answer')" v-model="answer" :maxlength="30" :placeholder="placeholder"></textarea>
          <button @click="submit" :class="getCss('submit')">提交</button>
        </div>
      </template>
      <!-- 加入俱乐部-审核中 -->
      <template v-if="isShowJoinApply">
        <img src="https://act.xinyue.qq.com/activity/tgclub/14011/78b238d4b75d6b44a07d219906de99b5.png"
             :class="getCss('content_close')" @click="close" />
        <div :class="getCss('content_apply')">
          <div :class="getCss('content_apply_header')">
            <h1>申请提交成功，请耐心等待通知</h1>
            <h2>将通过「心悦俱乐部」APP消息通知</h2>
          </div>
          <img :class="getCss('app-club-img')" src="https://act.xinyue.qq.com/act/common/assets/images/club/app-apply-notice.png" />
          <button
            :class="getCss('apply_button')"
            @click="handleJoinApplyButtonClick"
          >
            {{ isApp ? '好的' : '前往心悦俱乐部App' }}
          </button>
        </div>
      </template>
      <!-- 已加入俱乐部-社群列表 -->
      <template v-if="isShowJoinSuccess">
        <img src="https://act.xinyue.qq.com/activity/tgclub/14011/78b238d4b75d6b44a07d219906de99b5.png"
             :class="getCss('content_close')" @click="close" />
        <div :class="getCss('content_community')">
          <div :class="getCss('content_community_header')">
            <h1>加入成功, 一起来聊天吧</h1>
            <h2>请前往俱乐部微信群/qq群/qq频道</h2>
            <ul>
              <li v-for="(item, index) in welfareOption" :key="index">
                <img src="https://act.xinyue.qq.com/activity/tgclub/14011/99f8e5af6492febcb33011b0d91baee2.png" alt="" />
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
          <div :class="getCss('content_community_list')" ref="communityList">
            <ul
              :class="getCss('content_community_list_ul')"
              ref="communityListURl"
              v-if="currentCommunityList.length > 0"
            >
              <li @click="enterCommunity(listItem)" v-for="(listItem, index) in currentCommunityList" :key="index">
                <img :src="listItem.avator_url" alt="" />
                <p>{{ listItem.name }}({{ listItem.amount }}人)</p>
                <img src="https://act.xinyue.qq.com/act/common/assets/images/club/mores.png" alt="" />
              </li>
            </ul>
            <span v-else>暂无可加入的群聊</span>
          </div>
        </div>
      </template>
      <!-- 去群聊（未加入俱乐部，跳转俱乐部广场） -->
      <template v-if="isShowGoUnionSquare">
        <img src="https://act.xinyue.qq.com/activity/tgclub/14011/78b238d4b75d6b44a07d219906de99b5.png"
             :class="getCss('content_go-union-square_close')" @click="close" />
        <div :class="getCss('content_go-union-square')">
          <div :class="getCss('content_go-union-square_header')">
            <h1>您尚未加入俱乐部</h1>
            <h2>先去加入俱乐部吧</h2>
            <ul>
              <li v-for="(item, index) in welfareOption" :key="index">
                <img src="https://act.xinyue.qq.com/activity/tgclub/14011/99f8e5af6492febcb33011b0d91baee2.png" alt="" />
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
          <button @click="goUnionSquare" :class="getCss('go-union-square-btn')">进入俱乐部广场</button>
        </div>
      </template>
      <!-- 去群聊（已加入俱乐部，跳转群聊） -->
      <template v-if="isShowJoinChat">
        <img src="https://act.xinyue.qq.com/activity/tgclub/14011/78b238d4b75d6b44a07d219906de99b5.png"
             :class="getCss('content_chat_close')" @click="close" />
        <div :class="getCss('content_chat')">
          <div :class="getCss('content_chat_header')">
            <h1>加入俱乐部社群，一起聊天</h1>
            <div :class="getCss('club')">
              <span>{{ `近期加入：${currentClubName}` }}</span>
              <div>
                <img src="https://act.xinyue.qq.com/act/common/assets/images/club/change.png"/>
                <span @click="openSelectClub">切换俱乐部</span>
              </div>
              <span></span>
            </div>
            <ul>
              <li v-for="(item, index) in welfareOption" :key="index">
                <img src="https://act.xinyue.qq.com/activity/tgclub/14011/99f8e5af6492febcb33011b0d91baee2.png" alt="" />
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
          <div :class="getCss('content_chat_body')">
            <div :class="getCss('content_chat_list')" ref="chatList">
              <ul
                :class="getCss('content_chat_list_ul')"
                ref="chatListURl"
                v-if="currentCommunityList.length > 0"
              >
                <li @click="enterCommunity(listItem)" v-for="(listItem, index) in currentCommunityList" :key="index">
                  <img :src="listItem.avator_url" alt="" />
                  <p>{{ listItem.name }}({{ listItem.amount }}人)</p>
                  <img src="https://act.xinyue.qq.com/act/common/assets/images/club/mores.png" alt="" />
                </li>
              </ul>
              <span v-else>暂无可加入的群聊</span>
            </div>
          </div>
        </div>
      </template>
      <!-- 选择俱乐部 -->
      <template v-if="isShowSelectClub">
        <img src="https://act.xinyue.qq.com/activity/tgclub/14011/78b238d4b75d6b44a07d219906de99b5.png"
             :class="getCss('content_select_club_close')" @click="openJoinChat" />
        <div :class="getCss('content_select_club')">
          <div :class="getCss('content_select_club_header')">
            <h1>加入俱乐部社群，一起聊天</h1>
            <h2>请选择您想加入群聊的俱乐部</h2>
          </div>
          <div :class="getCss('content_select_club_body')">
            <template v-for="(item, index) in joinClubList">
              <div
                :class="getCss('item')"
                :key="`item-${index}`"
                @click="checkedJoinedClub({clubId: item.clubId})"
              >
                <span>{{ item.clubName }}</span>
                <img
                  src="https://act.xinyue.qq.com/act/common/assets/images/club/check.png"
                  v-show="currentClubId === item.clubId"
                />
              </div>
              <div :class="getCss('link')" :key="`link-${index}`"></div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import {
  OPEN_JOIN_CLUB_QUESTION,
  OPEN_JOIN_CLUB_APPLY,
  OPEN_JOIN_CLUB_SUCCESS,
  OPEN_GO_UNION_SQUARE,
  OPEN_JOIN_CHAT,
  OPEN_SELECT_CLUB,
} from './constant';

export default {
  name: 'CTgclubJoinClubPopup',
  mixins: [componentBaseMixin],
  props: {
    gid: {
      type: Number,
      default: 0,
    },
    clubId: {
      type: Number,
      default: 0,
    },
    problemData: {
      type: Object,
      default: () => ({}),
    },
    communityList: {
      type: Array,
      default: () => [],
    },
    joinClubList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cssPrefix: 'tgclub-join-club-popup-',
      popupShow: false,
      answer: '',
      placeholder: '',
      welfareOption: ['专属福利', '一手资源', '开黑服务'],
      showType: 0, // 弹窗显示类型
      showClubId: 0, // 需要展示的俱乐部id，不用props传递，因为在不同场景下有不同的值
      showCommunityList: [], // 需要展示的社群列表，不用props传递，因为在不同场景下有不同的值
    };
  },
  computed: {
    isApp() {
      return this.$ast.isAPP();
    },
    /**
     * 加入俱乐部-答题
     * @returns {boolean}
     */
    isShowJoinQuestion() {
      return this.showType === OPEN_JOIN_CLUB_QUESTION;
    },
    /**
     * 加入俱乐部-审核中
     * @returns {boolean}
     */
    isShowJoinApply() {
      return this.showType === OPEN_JOIN_CLUB_APPLY;
    },
    /**
     * 加入俱乐部成功-社群
     * @returns {boolean}
     */
    isShowJoinSuccess() {
      return this.showType === OPEN_JOIN_CLUB_SUCCESS;
    },
    /**
     * 去群聊-未加入俱乐部（跳转俱乐部广场）
     * @returns {boolean}
     */
    isShowGoUnionSquare() {
      return this.showType === OPEN_GO_UNION_SQUARE;
    },
    /**
     * 去群聊-已加入俱乐部（跳转群聊）
     * @returns {boolean}
     */
    isShowJoinChat() {
      return this.showType === OPEN_JOIN_CHAT;
    },
    /**
     * 选择俱乐部
     * @returns {boolean}
     */
    isShowSelectClub() {
      return this.showType === OPEN_SELECT_CLUB;
    },
    currentClubName() {
      const { clubName = '' } = this.joinClubList.find(item => item.clubId === this.currentClubId) || {};
      return clubName;
    },
    currentClubId() {
      console.log('【CTgclubJoinClubPopup】currentClubId', this.showClubId || this.clubId);
      return this.showClubId || this.clubId;
    },
    currentCommunityList() {
      if (this.showCommunityList.length > 0) {
        console.log('【CTgclubJoinClubPopup】currentCommunityList', this.showCommunityList);
        return this.showCommunityList;
      }
      console.log('【CTgclubJoinClubPopup】currentCommunityList', this.communityList);
      return this.communityList;
    },
  },
  mounted() {
    // 判断编辑环境或非编辑环境
    if (this.$isInEditor) {
      this.$refs.popupContent.style.display = 'none';
    }
  },
  methods: {
    /**
     * 浮层打开（供父组件调用）
     * @param type
     */
    async open({ type }) {
      switch (type) {
        case OPEN_JOIN_CLUB_QUESTION:
          this.openJoinClubQuestion();
          break;
        case OPEN_JOIN_CLUB_APPLY:
          this.openJoinClubApply();
          break;
        case OPEN_JOIN_CLUB_SUCCESS:
          this.openJoinClubSuccess();
          break;
        case OPEN_GO_UNION_SQUARE:
          this.openGoUnionSquare();
          break;
        case OPEN_JOIN_CHAT:
          // 近期加入的俱乐部
          // eslint-disable-next-line no-case-declarations
          const { clubId = 0 } = this.joinClubList?.[0] || {};
          console.log('【CTgclubJoinClubPopup】open this.joinClubList = ', this.joinClubList);
          console.log('【CTgclubJoinClubPopup】open clubId = ', clubId);
          this.showClubId = clubId;
          await this.openJoinChat();
          break;
        case OPEN_SELECT_CLUB:
          this.openSelectClub();
          break;
        default:
          break;
      }
    },
    openJoinClubQuestion() {
      this.showType = OPEN_JOIN_CLUB_QUESTION;
      const nickName = this.userInfo.nickName || 'xxx';
      this.answer = this.problemData.questionType === 2 ? `我是${nickName}` : '';
      this.placeholder = this.problemData.questionType === 2 ? `我是${nickName}` : '请输入答案，30个字以内';
      this.popupShow = true;
      document.body.style.overflowY = 'hidden';
      this.$refs.popupContent.style.animation = 'open-questions ease 0.5s forwards';
    },
    openJoinClubSuccess() {
      this.showType = OPEN_JOIN_CLUB_SUCCESS;
      this.popupShow = true;
      document.body.style.overflowY = 'hidden';
      this.$refs.popupContent.style.animation = 'open-community ease 0.5s forwards';
    },
    openJoinClubApply() {
      this.showType = OPEN_JOIN_CLUB_APPLY;
      this.popupShow = true;
      document.body.style.overflowY = 'hidden';
      this.$refs.popupContent.style.animation = 'open-apply ease 0.5s forwards';
    },
    openGoUnionSquare() {
      this.showType = OPEN_GO_UNION_SQUARE;
      this.popupShow = true;
      document.body.style.overflowY = 'hidden';
      this.$refs.popupContent.style.animation = 'open-go-union-square ease 0.5s forwards';
    },
    async openJoinChat() {
      const { list = [] } = await this.getCommunity() || {};
      this.showCommunityList = [...list];
      console.log('【CTgclubJoinClubPopup】clubOnChange this.showCommunityList = ', this.showCommunityList, ', clubId = ', this.currentClubId);
      this.showType = OPEN_JOIN_CHAT;
      this.popupShow = true;
      document.body.style.overflowY = 'hidden';
      this.$refs.popupContent.style.animation = 'open-join-chat ease 0.5s forwards';
    },
    openSelectClub() {
      this.showType = OPEN_SELECT_CLUB;
      this.popupShow = true;
      document.body.style.overflowY = 'hidden';
      this.$refs.popupContent.style.animation = 'open-select-club ease 0.5s forwards';
    },
    /**
     * 浮层关闭
     */
    close() {
      let animationName = '';
      if (this.isShowJoinQuestion) {
        animationName = 'close-questions';
      }
      if (this.isShowJoinApply) {
        animationName = 'close-apply';
      }
      if (this.isShowJoinSuccess) {
        animationName = 'close-community';
      }
      if (this.isShowGoUnionSquare) {
        animationName = 'close-go-union-square';
      }
      if (this.isShowJoinChat) {
        animationName = 'close-join-chat';
      }
      if (this.isShowSelectClub) {
        animationName = 'close-select-club';
      }
      this.clearInfo();
      this.$refs.popupContent.style.animation = `${animationName} ease 0.5s forwards`;
      document.body.style.overflowY = 'auto';
      this.popupShow = false;
    },
    /**
     * 每次关闭浮层，重置信息
     */
    clearInfo() {
      this.showClubId = 0;
      this.showCommunityList = [];
      this.showType = 0;
    },
    /**
     * 提示
    */
    openTips() {
      this.$alert({
        msg: '每个用户最多只能同时加入5个俱乐部，超过上限后需要到俱乐部主页点击退出，才能加入新的俱乐部',
        confirmText: '知道了',
        title: '加入俱乐部',
      });
    },
    /**
     * 提交答案
    */
    async submit() {
      const paramsData = {
        answer: this.answer,
        join_type: this.problemData.questionType,
      };
      if (this.currentClubId > 0) {
        paramsData.clubId = this.currentClubId;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.answerFlowID,
        params: {
          role: this.roleInfo,
          data: JSON.stringify(paramsData),
        },
      });
      const { ret, msg, data } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { ret: resRet, join_result: joinResult } = data || {};
      if (resRet !== 0) {
        return;
      }
      if (joinResult === 3) {
        this.toast('你填写的答案不匹配，请再次尝试');
      } else if (joinResult === 2) {
        this.open({ type: OPEN_JOIN_CLUB_APPLY });
        const args = { ret: 'check' };
        if (this.currentClubId > 0) {
          args.clubId = this.currentClubId;
        }
        this.$emit('submitStatus', { ...args });
      } else if (joinResult === 1) {
        this.open({ type: OPEN_JOIN_CLUB_SUCCESS });
        const args = { ret: 'success' };
        if (this.currentClubId > 0) {
          args.clubId = this.currentClubId;
        }
        this.$emit('submitStatus', { ...args });
      } else if (joinResult === 4) {
        this.toast('加入失败');
        this.close();
      }
    },
    /**
     * 进入社群
    */
    enterCommunity(obj) {
      if (obj.plat === 2) {
        window.location.href = obj.qrcode_url;
      } else {
        window.location.href = obj.chat_url;
      }
    },
    /**
     * 加入俱乐部-审核中弹窗按钮点击事件
     */
    handleJoinApplyButtonClick() {
      if (this.isApp) {
        this.close();
      } else {
        this.$ast.gotoAPP();
      }
    },
    /**
     * 跳转俱乐部广场
     */
    goUnionSquare() {
      window.location.href = `https://xinyue.qq.com/m/flutter_web/#/unionSquare?gid=${this.gid}`;
    },
    /**
     * 查询社群列表
     * @returns {Promise<{apply: *, join: *, list: *[]}>}
     */
    async getCommunity() {
      const paramsData = {};
      if (this.currentClubId > 0) {
        paramsData.clubId = this.currentClubId;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.communityFlowID,
        params: {
          role: this.roleInfo,
          data: JSON.stringify(paramsData),
        },
      });
      const { ret, msg, data } = response;
      if (ret !== 0) {
        this.$alert(msg);
        return;
      }
      const { ret: resRet, list = [], join, apply } = data || {};
      if (resRet !== 0) {
        return;
      }
      return { list, join, apply };
    },
    async checkedJoinedClub({ clubId }) {
      console.log('【CTgclubJoinClubPopup】checkJoinedClub clubId = ', clubId);
      this.showClubId = clubId;
    },
  },
};
</script>
<style lang="scss">
@import "./styles.scss";
</style>
